import { Card } from 'react-bootstrap';

export const BusinessReportDetails = (props: { denominacionEmpresa: string }) => {
  return (
    <Card>
      <Card.Header className="text-center">
        {props.denominacionEmpresa || 'EMPRESA'}{' '}
      </Card.Header>
      <Card.Body>
        <p className="fw-semibold text-center">Consolidado últimos meses</p>
      </Card.Body>
    </Card>
  );
};
